// utils/subscription-tracker.ts
import { MonoTypeOperatorFunction, Observable, OperatorFunction, defer } from 'rxjs';

/**
 * Tracks subscriptions per instance and handles cleanup.
 */
export class SubscriptionTracker<T extends object> {

    /**
     * Cache of tracked instances (optional).
     */
    private _instances = new WeakSet<T>();

    /**
     * 
     * @param context Debug label
     * @param trackByInstance If true (default), prevents duplicate subscriptions using WeakSet
     */
    constructor(
        private context = 'Tracked',
        private trackByInstance: boolean = true
    ) {}

    /**
     * Subscribes once per unique key (or always, if caching is disabled).
     *
     * @param key Unique key or instance (used to detect duplicates if `trackByInstance` is true)
     * @param observableFactory Lazy observable factory
     * @param next Callback when value emitted
     * @param operators RxJS pipeable operators
     */
    public once<V>(
        _instance: T,
        observableFactory: () => Observable<V>,
        next: (value: V) => void,
        ...operators: (OperatorFunction<any, any> | MonoTypeOperatorFunction<any>)[]
    ): void {

        // track by one instance
        if (this.trackByInstance) {
            
            // void duplicated ref
            if (this._instances.has(_instance)) return;
    
            // save ref
            this._instances.add(_instance);
            
        }


        // lazy load by defer
        defer(observableFactory)
            .pipe(...(operators as []))
            .subscribe({
            next,
            error: err =>
                console.warn(`[${this.context}] subscription error`, err),
            });
    }

    /**
     * 
     * @param ref 
     * @returns 
     */
    public hasInstance(ref: T): boolean {
        return this._instances.has(ref)
    }
}
